import { useEffect, useState } from "react";
import { CallPopUpAgentActions } from "../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../services/call_service";
import { WtButton } from "../../../shared/widges/Button/button";
import _ from "lodash";
import styles from "./incomingChat.module.scss";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { dispositionSliceActions } from "../../../store/slices/dispositionSlice/postDisposition";
import callChatService from "../../../base/service/chatService";
import { CallServices } from "../../../base/service/apiServices";
import { LocalStorage } from "../../../custom_hooks/localStorageKeys";
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import { ChatState } from "../../../base/models/model";
import { ChatActions } from "../../../store/slices/chat_slice/chat_slice";
import { RecordRTCPromisesHandler, StereoAudioRecorder } from "recordrtc";
import { outboundCampaignSliceAction } from "../../../store/slices/outboundCampaign/outboundCampaignslice";


function IncomingCallNotify() {
  const navigate = useNavigate();
  const dispatch = useDispatcher();
  const [over, setOver] = useState(false);
  const [buttonDis, setButtonDis] = useState(false);
  const [[m, s], setTime] = useState<any>([0, 29]);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  const domainId = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.domainId
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  let { incomingcallDetails, currentSession } = chatReducer;
  const LoginUserDetails = GetItemFromStorage(
    LocalStorage.LOGIN_USER_CCAAS_DETAILS
  );
  let { callSessionDetailswhilePopup } = popUpDetails;
  let { acceptCallFunction, declineCallFunction } = CallService(dispatch, navigate);


  const microphone = async () => {
    const stream = await navigator?.mediaDevices.getUserMedia({ audio: true });
    //setStream(stream)
    let recorder = new RecordRTCPromisesHandler(stream, {
      type: "audio",
      mimeType: "audio/wav",
      recorderType: StereoAudioRecorder,
      numberOfAudioChannels: 1,
    });
    if (Object.values(recorder).length > 0) {
    } else {
      alert('Microphone access has been denied. Please enable it in your browser settings or exit incognito mode.')
      return;
    }
  }
  useEffect(() => {
    microphone()
  }, [])

  const acceptNotify = () => {
    // try {
    //   const agentID = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.UserID
    //   if (agentID) {
    //     CallServices.get(`/incall?agentId=${agentID}&status=0`)
    //   }
    // } catch (error) {
    //   console.log(error)
    // }
    setButtonDis(true)
    // setTimeout(() => {
      acceptCallFunction(callSessionDetailswhilePopup.userAgent, callSessionDetailswhilePopup.fromcaller);
      callChatService.callDashboard(domainId)
      dispatch(ChatActions.answeredDuration(29 - s));
      dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: false }));
    // }, 2000);
    // setTimeout(()=>{
    //   const body: any = {
    //     CallHistoryId:currentSession?.CallHistoryId,
    //     domainId: LoginUserDetails?.domainId,
    //     AgentId: LoginUserDetails.UserID,
    //     answeredDuration: 29-s
    //   }
    //   callChatService.callNotifyDialDuration(body)
    // },2000);
  };
  const declineNotify = () => {
    try {
      const agentID = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.UserID
      if (agentID) {
        CallServices.get(`/incall?agentId=${agentID}&status=1`)
      }
      callChatService.callDashboard(domainId)
    } catch (error) {
      console.log(error)
    }
    setOver(true);
    declineCallFunction(callSessionDetailswhilePopup.userAgent);
    dispatch(CallPopUpAgentActions.setCloseCall(false));
    CallPopUpAgentActions.setWholeData({
      acceptCallRoom: false,
      callRoomInfo: "",
      callSessionId: "",
      callSessionDetailswhilePopup: "",
      isCallAccepted: false,
    });
    dispatch(CallPopUpAgentActions.setTransferFrom([]))
    dispatch(CallPopUpAgentActions.setTransferReset())
    dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
  
  };

  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    const ringer: any = document.getElementById("ringer");
    if (over) {
      ringer.pause();
      clearInterval(timerID);
      callChatService.callDashboard(domainId)
      dispatch(CallPopUpAgentActions.NotAttendedCall());
      dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
      
      // dispatch(CallPopUpAgentActions.setCloseCall(false));
    }
    return () => {
      clearInterval(timerID);
    };
  });

  const tick = () => {
    if (m === 0 && s === 0) {
      setOver(true);
      callChatService.callDashboard(domainId)
    } else {
      setTime([m, s - 1]);
    }
  };

  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <div className={styles.incomingTop}>
          <span>
            <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="64.8891" height="64.8891" rx="22.3056" fill="#000" />
              <g clip-path="url(#clip0_3091_352635)">
                <g filter="url(#filter0_d_3091_352635)">
                  <path d="M18.9808 16.8231L19.3579 16.5678C21.4622 15.2178 24.2476 15.6922 25.8651 17.6751L28.0791 20.3995C29.4535 22.0903 29.648 24.4744 28.5411 26.3355L26.7287 29.4128C26.4369 29.8991 27.3003 31.4442 29.4533 33.6211C31.6305 35.7743 33.1756 36.6377 33.6742 36.3583L36.7395 34.5333C38.6126 33.4388 40.9845 33.6211 42.6873 35.0077L45.4119 37.2217C47.3946 38.8394 47.8691 41.625 46.5067 43.7169L46.2634 44.1064C44.4148 46.9769 40.9724 48.6917 37.5059 48.0719C33.0174 47.2564 28.371 44.4107 23.5057 39.5696C18.6767 34.7162 15.8183 30.0577 15.0155 25.5815C14.3953 22.1148 16.1101 18.6722 18.9808 16.8231Z" fill="white" />
                  <path d="M41.0483 15.8164C40.5582 15.7277 40.0896 16.0536 40.0014 16.5437C39.9129 17.0332 40.2386 17.5019 40.7287 17.5906C44.1965 18.1964 47.0464 21.4747 47.2881 25.0002C47.3078 25.2733 47.313 25.5469 47.3024 25.8203C47.2823 26.3178 47.6697 26.7369 48.1674 26.7565C48.6647 26.7762 49.0839 26.3892 49.1038 25.8917C49.1171 25.5483 49.1104 25.2064 49.0855 24.869C48.7505 20.4992 45.4009 16.6208 41.0483 15.8164Z" fill="white" />
                  <path d="M39.774 19.7454C39.2839 19.6573 38.8152 19.9826 38.7273 20.4727C38.6391 20.9628 38.9646 21.4315 39.4547 21.5196C41.4182 21.8532 43.0763 23.7556 43.207 25.7628L43.2151 26.23C43.1958 26.7273 43.5833 27.146 44.081 27.1653C44.5783 27.1846 44.9972 26.7971 45.0165 26.2998C45.0247 26.0759 45.0206 25.8526 45.0046 25.6318C44.7803 22.7801 42.6226 20.2777 39.774 19.7454Z" fill="white" />
                </g>
              </g>
            </svg>
          </span>
          <span>Incoming Call...</span>
        </div>
        <div className={styles.callwhisperinnercon}>
          <div className={styles.succesconsec}>
            {/* <div className={styles.calliconsec}>
              <span className="icon__Call36"></span>
            </div> */}
            {/* <div className={styles.userconsec}>
              <span>
                {!_.isEmpty(callSessionDetailswhilePopup)
                  ? (callSessionDetailswhilePopup.contactDetails.firstName === "") ? "New Customer" :
                    callSessionDetailswhilePopup.contactDetails.firstName
                  : `New Customer(${callSessionDetailswhilePopup.fromcaller})`}
              </span>
              <label className={styles.phnenumber}>+{callSessionDetailswhilePopup.fromcaller}</label>
            </div> */}
            {callSessionDetailswhilePopup.contactDetails.firstName?.length > 20 ?
              <div className={`${styles.userconsec} ${styles.widthfull}`}>
                <div className={"marqueeWrapper"}>
                  <span className="marqueeEffect">{!_.isEmpty(callSessionDetailswhilePopup)
                    ? (callSessionDetailswhilePopup.contactDetails.firstName === "") ? "New Customer" :
                      callSessionDetailswhilePopup.contactDetails.firstName
                    : `New Customer(${callSessionDetailswhilePopup.fromcaller})`}</span>

                  <span className="marqueeEffect">{!_.isEmpty(callSessionDetailswhilePopup)
                    ? (callSessionDetailswhilePopup.contactDetails.firstName === "") ? "New Customer" :
                      callSessionDetailswhilePopup.contactDetails.firstName
                    : `New Customer(${callSessionDetailswhilePopup.fromcaller})`}</span>
                </div>
                <label className={styles.phnenumber}>+{callSessionDetailswhilePopup.fromcaller}</label>
              </div>
              :
              <div className={styles.userconsec}>
                <span>{!_.isEmpty(callSessionDetailswhilePopup)
                  ? (callSessionDetailswhilePopup.contactDetails.firstName === "") ? "New Customer" :
                    callSessionDetailswhilePopup.contactDetails.firstName
                  : `New Customer(${callSessionDetailswhilePopup.fromcaller})`}</span>
                <label className={styles.phnenumber}>+{callSessionDetailswhilePopup.fromcaller}</label>
              </div>
            }
            <div className={styles.supportconsec}>
              <span className={styles.curntsuprt}>{incomingcallDetails?.queueName}</span> {/* {callSessionDetailswhilePopup?.queueName ?? ""} */}
              <label className={styles.anstxt}>
                Answer in{" "}
                <span className={styles.timecount}>
                  <p>{`${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`}</p>
                </span>
              </label>
            </div>
            <div className={styles.acceptbtnconsec}>
              <WtButton className={buttonDis ? `buttonGreen ${styles.declinebtn} ${styles.disabledbtn}` :`buttonGreen ${styles.declinebtn}`} onClick={declineNotify} onTouchStart={declineNotify} name="Decline" />
              <WtButton className={buttonDis ? `buttonGreen ${styles.acceptbtn} ${styles.disabledbtn}`:`buttonGreen ${styles.acceptbtn}`} onClick={acceptNotify}  onTouchStart={acceptNotify} name="Accept" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default IncomingCallNotify;
